import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
  Toolbar,
  Divider,
  Tab,
  Tabs,
} from "@mui/material";
import {
  BusinessCenterOutlined,
  DateRangeOutlined,
  HowToRegOutlined,
  InfoOutlined,
  OpenInNewRounded,
  PersonOffOutlined,
} from "@mui/icons-material";
import ListAltIcon from '@mui/icons-material/ListAlt';
import CountUp from 'react-countup';
import { useNavigate } from "react-router-dom";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../Components/redux/selector";
import { userSelector } from "../../Components/user-redux/selector";
import {
  getCandidateDetailAction,
  getcandidateSubmissionsAction,
  getLatestSolrJobsAction,
  getSolrJobsAction,
  selectedCandidateAction,
} from "../redux/action";
import Candidatedashboardjobs from "./Candidatedashboardjobs";
import Candidatedashboardsubmissions from "./Candidatedashboardsubmissions";
import Candidatedashboardinterviews from "./Candidatedashboardinterviews";
import Key from "../../clientVariables.json";
import generateSolrQuery from "../../helpers/solr";
import Candidateprofile from "../Settings/Candidateprofile";
import axios from "axios";
import { myCandidatesSelector } from "../MyCandidates/redux/selector";
import { getCandidateInterestedJobs } from "../MyCandidates/redux/action";
import generateEdismaxSolrQuery from "../../helpers/solredismax";
import { getMappedDates } from "../utils/utils";

const CandidateDashboard = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  // Define breakpoints for different screen sizes
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm")); // Regular mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Desktops and larger
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  const [tasks, setTasks] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(200);
  const { user } = useSelector(userSelector);
  // State to manage active tab
  const [activeTab, setActiveTab] = useState(0);
  const { solrJobs, candidateDetails, loginCandidate, jobtype_jobids } =
    useSelector(appSelector);
  // const {candidateDetails , selectedJob} = useSelector(appSelector)
  const [firstTimeLoading, setFirstTimeLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [isGridView, setIsGridView] = useState(true);
  const [candidateSubmissions, setCandidateSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [interviewCount, setInterviewCount] = useState(0);

  const { candidateInterestedJobs } = useSelector(myCandidatesSelector);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleViewAllClick = () => {
    navigate("/candidates-list");
  };
  const handleViewAllClick1 = () => {
    navigate("/candidates-list", { state: { selectedTab: 2 } });
  };

  const handleViewAllinterviewClick = () => {
    navigate("/candidates-list", { state: { selectedTab: 3 } });
  };

  const handleViewAlltodoClick = () => {
    navigate("/todo-list", { state: { selectedTab: 3 } });
  };

  // Modern card styles inspired by Recruiterdashboard.js
  const colors = {
    primary: {
      main: "#667eea",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      light: "#f093fb"
    },
    secondary: {
      main: "#f093fb",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      light: "#ffecd2"
    },
    success: {
      main: "#4facfe",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      light: "#a8edea"
    },
    warning: {
      main: "#fd9644",
      gradient: "linear-gradient(135deg, #fd9644 0%, #fe4a49 100%)",
      light: "#fed6e3"
    },
    info: {
      main: "#a8edea",
      gradient: "linear-gradient(135deg, #628f8dff 0%, #e91d5eff 100%)",
      light: "#7b2964ff"
    },
    background: "#fafbfc",
    surface: "#ffffff",
    text: "#2d3748",
    textSecondary: "#718096",
    border: "#e2e8f0",
  };
  const cardStyles = {
    p: { xs: 2, sm: 2.5, md: 2 },
    borderRadius: "20px",
    background: `linear-gradient(145deg, ${colors.surface} 0%, ${colors.background} 100%)`,
    border: `1px solid ${colors.border}`,
    boxShadow: `0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04), inset 0 1px 0 #fff`,
    position: "relative",
    overflow: "hidden",
    backdropFilter: "blur(20px)",
    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    cursor: "pointer",
    '&:hover': {
      transform: "translateY(-2px)",
      boxShadow: `0 8px 20px rgba(0,0,0,0.08), 0 4px 10px rgba(0,0,0,0.04), inset 0 1px 0 #fff`,
      borderColor: colors.primary.main,
    }
  };

  const dispatch = useDispatch();

  const { candidateSubmissions: reduxCandidateSubmissions, latestSolrJobs } = useSelector(appSelector);

  const getTasks = async () => {
    try {
      const response = await axios.post(`${Key.domain}/task/get_TodoTasks`, {
        user_id: user?.id,
      });


      const data = response?.data?.data?.data;
      setTasks(data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  // useEffect(() => {
  //   if (activeTab === 1) {
  //     getTasks(); // Fetch tasks when the "Tasks" tab is active
  //   }
  // }, [activeTab]);

  useEffect(() => {
    getTasks(); // Fetch tasks when the component mounts
  }, []); // Empty dependency array ensures it runs only once


  useEffect(() => {
    const fetch = async () => {
      const response = await dispatch(
        getCandidateDetailAction(user?.candidate_id)
      );
      await dispatch(selectedCandidateAction(response.candidate));
    };
    fetch();
  }, []);

  const setSolrJobsState = async (solrURL) => {
    if (!solrURL) return;
    const data = await dispatch(getSolrJobsAction(solrURL));
    await setJobs(data);
  };

  useEffect(() => {
    if (candidateDetails && candidateDetails?.role) {
      setPage(0);
      //let solrURL = getSolrQuery(0);
      const searchTerm = "";
      const dayCount = "";
      const selectedJobtypeFilter = "";
      const locationSearchTerm = ""
      let solrURL = getSolrQuery(0, searchTerm, dayCount, selectedJobtypeFilter, locationSearchTerm);
      // dispatch(getSolrJobsAction(solrURL));
      setSolrJobsState(solrURL)
      //
    }
  }, [candidateDetails]);



  const getSolrQuery = (
    updatedPage,
    searchTerm,
    dayCount,
    selectedJobtypeFilter,
    locationSearchTerm
  ) => {
    setPage(updatedPage);

    let exactTitles = [];

    if (candidateDetails?.related_titles) {
      exactTitles = exactTitles.concat(candidateDetails.related_titles.split(","));
    }
    if (candidateDetails?.role) {
      exactTitles.push(candidateDetails.role);
    }
    const cleanedTitles = exactTitles
      .filter(Boolean)
      .map(title => `"${title.trim()}"`);


    const combinedString = cleanedTitles.join(" OR ");

    const sort_key = searchTerm
      ? `if(exists(query({!v='jobtitle:${searchTerm}'})), 0, 1) asc, posted_date%20desc&wt=json`
      : `posted_date desc&wt=json`;

    const daysFilter = dayCount ? getMappedDates(dayCount) : "[* TO *]";

    // Create a base query params object
    const queryParams = {
      jobtitle: "(" + combinedString + ")",
      posted_date: daysFilter,
    };

    // Add location to query params if search term exists
    if (locationSearchTerm && locationSearchTerm.trim() !== "") {
      queryParams.location = `"${locationSearchTerm.trim()}"`;  // Using quotes for exact matching
    }

    if (searchTerm && searchTerm != "") {
      // Handle job title search term
      const generatedSolrQuery = generateEdismaxSolrQuery(
        queryParams,
        updatedPage,
        limit,
        sort_key
      );
      return generatedSolrQuery;
    } else if (
      selectedJobtypeFilter &&
      jobtype_jobids &&
      jobtype_jobids.length > 0
    ) {
      setPage(0);

      const orCondition =
        jobtype_jobids && jobtype_jobids?.length > 0
          ? jobtype_jobids?.map((id) => id).join(" OR ")
          : jobtype_jobids;

      const jobTypeQueryParams = {
        id: "(" + orCondition + ")",
        posted_date: daysFilter,
      };

      // Add location to job type filter query if available
      if (locationSearchTerm && locationSearchTerm.trim() !== "") {
        jobTypeQueryParams.location = `"${locationSearchTerm.trim()}"`;
      }

      const sort_key = `posted_date desc&wt=json`;
      const generatedSolrQuery = generateEdismaxSolrQuery(
        jobTypeQueryParams,
        0,
        limit,
        sort_key
      );
      return generatedSolrQuery;
    } else {
      // Default query
      const generatedSolrQuery = generateEdismaxSolrQuery(
        queryParams,
        updatedPage,
        limit,
        sort_key
      );
      return generatedSolrQuery;
    }
  };

  useEffect(() => {
    if (user && user.candidate_id) {
      dispatch(getCandidateInterestedJobs(user.candidate_id));
    }
  }, [user, dispatch]);

  const getSubmissionsCandidate = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${Key.domain}/candidate/${user?.candidate_id}/submissions/0/200`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      setCandidateSubmissions(data?.data?.submissions || []);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.candidate_id) {
      getSubmissionsCandidate();
    }
  }, [user?.candidate_id]);

  return (
    <Box sx={{ height: "calc(100vh - 64px)", display: "flex", flexDirection: "column", overflow: "hidden", pt: 1, pb: 0, mx: { xs: -0.5, md: -1 } }}>
      {(() => {
        const sessionToken = user?.session_token;

        if (!sessionToken) {
          return <Candidateprofile />;
        }
      })()}
      <Box sx={{ flexShrink: 0 }}>
        <Grid container spacing={1}>
          <Grid item xs={4} sm={3} md={2.2}>
            <Card sx={cardStyles}>
              <Stack spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box
                    sx={{
                      height: { xs: 52, sm: 60 },
                      width: { xs: 52, sm: 60 },
                      borderRadius: "16px",
                      background: colors.warning.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `0 8px 25px rgba(0,0,0,0.1), 0 3px 10px rgba(0,0,0,0.05)`,
                      transition: "all 0.4s ease",
                      '&:hover': { transform: "scale(1.02)" }
                    }}
                  >
                    <HowToRegOutlined sx={{ fontSize: { xs: 26, sm: 30 }, color: "#ffffff", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }} />
                  </Box>
                  <Typography
                    variant="h3"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                      lineHeight: 1.1,
                      background: colors.warning.gradient,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                    }}
                  >
                    <CountUp
                      end={candidateSubmissions?.filter((job) => [3, 5, 7].includes(Number(job.bench_status_id))).length || 0}
                      duration={2}
                      separator=","
                      decimals={0}
                      decimal="."
                      prefix=""
                      suffix=""
                      enableScrollSpy={true}
                      scrollSpyOnce={true}
                      delay={0.3}
                    />
                  </Typography>
                </Stack>
                <Stack spacing={1}>
                  <Typography
                    variant="h6"
                    sx={{ fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' }, fontWeight: 600, color: colors.text, lineHeight: 1.3, letterSpacing: '-0.025em' }}
                  >
                    Submissions
                  </Typography>
                  {/* <Typography
                    variant="body1"
                    sx={{ fontSize: { xs: '0.85rem', sm: '0.9rem' }, color: colors.textSecondary, lineHeight: 1.5, fontWeight: 500 }}
                  >
                    Submitted jobs
                  </Typography> */}
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={4} sm={3} md={2.2}>
            <Card sx={cardStyles}>
              <Stack spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box
                    sx={{
                      height: { xs: 52, sm: 60 },
                      width: { xs: 52, sm: 60 },
                      borderRadius: "16px",
                      background: colors.secondary.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `0 8px 25px rgba(0,0,0,0.1), 0 3px 10px rgba(0,0,0,0.05)`,
                      transition: "all 0.4s ease",
                      '&:hover': { transform: "scale(1.02)" }
                    }}
                  >
                    <CalendarTodayIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: "#ffffff", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }} />
                  </Box>
                  <Typography
                    variant="h3"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                      lineHeight: 1.1,
                      background: colors.secondary.gradient,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                    }}
                  >
                    <CountUp
                      end={interviewCount || 0}
                      duration={2}
                      separator=","
                      decimals={0}
                      decimal="."
                      prefix=""
                      suffix=""
                      enableScrollSpy={true}
                      scrollSpyOnce={true}
                      delay={0.3}
                    />
                  </Typography>
                </Stack>
                <Stack spacing={1}>
                  <Typography
                    variant="h6"
                    sx={{ fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' }, fontWeight: 600, color: colors.text, lineHeight: 1.3, letterSpacing: '-0.025em' }}
                  >
                    Interviews
                  </Typography>
                  {/* <Typography
                    variant="body1"
                    sx={{ fontSize: { xs: '0.85rem', sm: '0.9rem' }, color: colors.textSecondary, lineHeight: 1.5, fontWeight: 500 }}
                  >
                    Scheduled meetings
                  </Typography> */}
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={4} sm={3} md={2.2}>
            <Card sx={cardStyles}>
              <Stack spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box
                    sx={{
                      height: { xs: 52, sm: 60 },
                      width: { xs: 52, sm: 60 },
                      borderRadius: "16px",
                      background: colors.success.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `0 8px 25px rgba(0,0,0,0.1), 0 3px 10px rgba(0,0,0,0.05)`,
                      transition: "all 0.4s ease",
                      '&:hover': { transform: "scale(1.02)" }
                    }}
                  >
                    <ThumbUpOffAltIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: "#ffffff", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }} />
                  </Box>
                  <Typography
                    variant="h3"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                      lineHeight: 1.1,
                      background: colors.success.gradient,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                    }}
                  >
                    <CountUp
                      end={candidateInterestedJobs?.length || 0}
                      duration={2}
                      separator=","
                      decimals={0}
                      decimal="."
                      prefix=""
                      suffix=""
                      enableScrollSpy={true}
                      scrollSpyOnce={true}
                      delay={0.3}
                    />
                  </Typography>
                </Stack>
                <Stack spacing={1}>
                  <Typography
                    variant="h6"
                    sx={{ fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' }, fontWeight: 600, color: colors.text, lineHeight: 1.3, letterSpacing: '-0.025em' }}
                  >
                    Interested
                  </Typography>
                  {/* <Typography
                    variant="body1"
                    sx={{ fontSize: { xs: '0.85rem', sm: '0.9rem' }, color: colors.textSecondary, lineHeight: 1.5, fontWeight: 500 }}
                  >
                    Engaged candidates
                  </Typography> */}
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={4} sm={3} md={2.2}>
            <Card sx={cardStyles}>
              <Stack spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box
                    sx={{
                      height: { xs: 52, sm: 60 },
                      width: { xs: 52, sm: 60 },
                      borderRadius: "16px",
                      background: colors.info.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `0 8px 25px rgba(0,0,0,0.1), 0 3px 10px rgba(0,0,0,0.05)`,
                      transition: "all 0.4s ease",
                      '&:hover': { transform: "scale(1.02)" }
                    }}
                  >
                    <ListAltIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: "#ffffff", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }} />
                  </Box>
                  <Typography
                    variant="h3"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                      lineHeight: 1.1,
                      background: colors.info.gradient,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                    }}
                  >
                    <CountUp
                      end={tasks?.length || 0}
                      duration={2}
                      separator=","
                      decimals={0}
                      decimal="."
                      prefix=""
                      suffix=""
                      enableScrollSpy={true}
                      scrollSpyOnce={true}
                      delay={0.3}
                    />
                  </Typography>
                </Stack>
                <Stack spacing={1}>
                  <Typography
                    variant="h6"
                    sx={{ fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' }, fontWeight: 600, color: colors.text, lineHeight: 1.3, letterSpacing: '-0.025em' }}
                  >
                    Tasks
                  </Typography>
                  {/* <Typography
                    variant="body1"
                    sx={{ fontSize: { xs: '0.85rem', sm: '0.9rem' }, color: colors.textSecondary, lineHeight: 1.5, fontWeight: 500 }}
                  >
                    To-do list
                  </Typography> */}
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: "hidden", mt: 1, pb: 0, display: "flex", flexDirection: "column" }}>
        <Grid container spacing={1} sx={{ flex: 1, height: "100%", width: "100%" }}>
          <Grid item xs={isMobile || isTablet ? 12 : 4} sx={{ height: "100%", pt: "0 !important" }}>
            <Paper
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #ddd",
                borderRadius: "0 0 10px 10px",
                overflow: "hidden",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
                <Toolbar
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: 0,
                    minHeight: 48,
                    borderRadius: "0 0 8px 8px",
                  }}
                >
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="tabs for upcoming interviews and tasks"
                    sx={{
                      minHeight: 48,
                      "& .MuiTabs-indicator": {
                        height: 3,
                        borderRadius: "4px",
                      },
                      "& .MuiTab-root": {
                        textTransform: "none",
                        borderRadius: "8px 8px 0 0",
                      },
                    }}
                  >
                    <Tab
                      label="Upcoming Interviews"
                      sx={{
                        fontSize:
                          isMobile || isMobileSmall || isDesktopSmall
                            ? "12px"
                            : "14px",
                      }}
                    />
                    <Tab
                      label="Tasks"
                      sx={{
                        fontSize:
                          isMobile || isMobileSmall || isDesktopSmall
                            ? "12px"
                            : "14px",
                      }}
                    />
                  </Tabs>

                  <Typography
                    variant="body1"
                    style={{
                      fontSize:
                        isMobile || isMobileSmall || isDesktopSmall
                          ? "12px"
                          : "14px",
                      cursor: "pointer",
                      marginRight: "12px",
                    }}
                    onClick={
                      activeTab === 0
                        ? handleViewAllinterviewClick
                        : activeTab === 1
                          ? handleViewAlltodoClick
                          : undefined
                    }
                  >
                    View All
                  </Typography>
                </Toolbar>
                <Divider />

                <Box
                  sx={{
                    flexGrow: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    backgroundColor: "#f4f6f8",
                  }}
                >
                  {activeTab === 0 && (
                    <Candidatedashboardinterviews setInterviewCount={setInterviewCount} />
                  )}
                  {activeTab === 1 && (
                    <Box sx={{ padding: "16px 16px 8px 16px", }}>
                      {tasks?.length > 0 ? (
                        tasks.slice(0, 4).map((task, index) => (
                          <Grid item xs={12} sm={12} md={12} key={index}>
                            <Paper
                              elevation={3}
                              sx={{
                                borderRadius: "8px",
                                padding: "11px",
                                marginBottom: "16px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #ddd",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                  transform: "translateY(-4px)",
                                  boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
                                },
                              }}
                            >
                              <Grid container spacing={2} alignItems="center">
                                {/* Left Side - Text Content */}
                                <Grid item lg={9} md={8} sm={9}>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      textDecoration: task.completed
                                        ? "line-through"
                                        : "none",
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                      marginBottom: 1,
                                      color: "#000",
                                    }}
                                  >
                                    {task.title}
                                  </Typography>

                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#666666",
                                      fontSize: "13px",
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      WebkitLineClamp: 5,
                                      overflow: "hidden",
                                      lineHeight: "24px",
                                      wordWrap: "break-word",

                                    }}
                                  >
                                    {task.content
                                      ? task.content.length > 65
                                        ? task.content.slice(0, 45) + "..."
                                        : task.content
                                      : "Description..."}
                                  </Typography>
                                </Grid>

                                {/* Right Side - Date Box */}
                                <Grid item lg={3} md={4} sm={3}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "8px",
                                      backgroundColor: "#fefefe",
                                      padding: "12px 0",
                                      boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                                      width: { xs: "100px", sm: "100px", md: "80px", lg: "90px" },
                                      margin: "0 auto",
                                    }}
                                  >
                                    {task?.created && (
                                      <>
                                        <Typography
                                          variant="h4"
                                          sx={{
                                            color: "#2d9596",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {new Date(task.created).getDate()}
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            backgroundColor: "#ff4f4f",
                                            color: "#fff",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            fontWeight: "600",
                                            marginBottom: "4px",
                                            textTransform: "uppercase",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {new Date(
                                            task.created
                                          ).toLocaleDateString("en-US", {
                                            month: "short",
                                            year: "numeric",
                                          })}
                                        </Typography>
                                      </>
                                    )}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        ))
                      ) : (
                        <Grid item xs={12}>
                          <Typography variant="body1" textAlign="center">
                            No tasks found matching your search criteria
                          </Typography>
                        </Grid>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={isMobile || isTablet ? 12 : 4} sx={{ height: "100%", pt: "0 !important" }}>
            <Paper
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "0 0 10px 10px",
                overflow: "hidden",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
                <Toolbar
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    minHeight: 48,
                    borderRadius: "0 0 8px 8px",
                  }}
                >
                  <Typography variant="body1">Latest Jobs</Typography>
                  <Typography
                    variant="body1"
                    style={{ fontSize: "14px", cursor: "pointer" }} // Add cursor pointer for UX
                    onClick={handleViewAllClick} // Attach click handler
                  >
                    View All
                  </Typography>
                </Toolbar>
                <Divider />
                <Box sx={{ flexGrow: 1, minHeight: 0, overflowY: "auto" }}>
                  <Candidatedashboardjobs />
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={isMobile || isTablet ? 12 : 4} sx={{ height: "100%", pt: "0 !important" }}>
            <Paper
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "0 0 10px 10px",
                overflow: "hidden",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
                <Toolbar
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    minHeight: 48,
                    borderRadius: "0 0 8px 8px",
                  }}
                >
                  <Typography variant="body1">Submissions</Typography>
                  <Typography
                    style={{ fontSize: "14px", cursor: "pointer" }} // Add cursor pointer for UX
                    variant="body1"
                    onClick={handleViewAllClick1}
                  >
                    View All
                  </Typography>
                </Toolbar>
                <Divider />
                <Box sx={{ flexGrow: 1, minHeight: 0, overflowY: "auto", backgroundColor: "#f4f6f8" }}>
                  <Candidatedashboardsubmissions />
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CandidateDashboard;
